import { Activity } from '@/types';
import { getActivitiesByCategory } from '@/services/activityService';

export interface Category {
  id: string;
  label: string;
  icon: string;
  imageUrl: string;
  description: string;
  gradient: string;
}

export const categories: Category[] = [
  {
    id: 'bowling',
    label: 'Bowling',
    icon: '🎳',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/bowling_star_paris/bowling1.webp',
    description: 'Pistes modernes et ambiance festive',
    gradient: 'from-purple-500 to-pink-500'
  },
  {
    id: 'karting',
    label: 'Karting',
    icon: '🏎️',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/karting/kar1.jpg',
    description: 'Courses palpitantes sur piste indoor',
    gradient: 'from-red-500 to-orange-500'
  },
  {
    id: 'escape-game',
    label: 'Escape Game',
    icon: '🔐',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/koezio/ko1.jpg',
    description: 'Énigmes et aventures immersives',
    gradient: 'from-indigo-500 to-purple-500'
  },
  {
    id: 'laser-game',
    label: 'Laser Game',
    icon: '🔫',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/rg_laser_game/lg1.jpg',
    description: 'Combats tactiques et adrénaline',
    gradient: 'from-cyan-500 to-blue-500'
  },
  {
    id: 'padel',
    label: 'Padel',
    icon: '🎾',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/padel/pad.jpg',
    description: 'Terrains premium et ambiance sportive',
    gradient: 'from-green-500 to-emerald-500'
  },
  {
    id: 'foot-indoor',
    label: 'Foot Indoor',
    icon: '⚽',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/padel/pad2.jpg',
    description: 'Terrains synthétiques de qualité',
    gradient: 'from-lime-500 to-green-500'
  },
  {
    id: 'trampoline-park',
    label: 'Trampoline Park',
    icon: '🤸',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/bowling_star_paris/bowling3.jpg',
    description: 'Sauts et acrobaties pour tous',
    gradient: 'from-yellow-500 to-orange-500'
  },
  {
    id: 'billard',
    label: 'Billard',
    icon: '🎱',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/bowling_star_paris/bowling4.jpg',
    description: 'Tables professionnelles et ambiance lounge',
    gradient: 'from-slate-500 to-gray-600'
  },
  {
    id: 'paintball-indoor',
    label: 'Paintball Indoor',
    icon: '🎨',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/rg_laser_game/lg2.jpg',
    description: 'Action tactique en milieu urbain',
    gradient: 'from-orange-500 to-red-500'
  },
  {
    id: 'vr-arcade',
    label: 'VR Arcade',
    icon: '🥽',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activity-images/koezio/ko3.jpg',
    description: 'Expériences immersives en réalité virtuelle',
    gradient: 'from-violet-500 to-fuchsia-500'
  },
  {
    id: 'Quiz-room',
    label: 'Quiz Room',
    icon: '🧩',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activities/activity-images/bd55d3f5-f476-49dc-87ff-336eeade0681/1772623478995-10e80v.jpg',
    description: 'Défis culturels et soirées quiz',
    gradient: 'from-amber-500 to-yellow-500'
  },
  {
    id: 'autre',
    label: 'Activités insolites',
    icon: '✨',
    imageUrl: 'https://tfchhwvznjbfpigluznd.supabase.co/storage/v1/object/public/activities/activity-images/242ed52a-7904-4852-904b-86914acb42e1/1772720311133-8bdv7.jpg',
    description: 'Expériences uniques et inattendues',
    gradient: 'from-teal-500 to-cyan-500'
  }
];

/**
 * Get all venues for a specific category (now async, fetches from DB)
 */
export const getVenuesByCategory = async (categoryId: string): Promise<Activity[]> => {
  return await getActivitiesByCategory(categoryId);
};

/**
 * Get the count of venues for a specific category (now async, fetches from DB)
 */
export const getVenueCountByCategory = async (categoryId: string): Promise<number> => {
  const activities = await getActivitiesByCategory(categoryId);
  return activities.length;
};

/**
 * Get category by ID
 */
export const getCategoryById = (categoryId: string): Category | undefined => {
  return categories.find(cat => cat.id === categoryId);
};

/**
 * Get all categories with their venue counts (now async)
 */
export const getCategoriesWithCounts = async (): Promise<(Category & { venueCount: number })[]> => {
  const counts = await Promise.all(
    categories.map(async (category) => ({
      ...category,
      venueCount: await getVenueCountByCategory(category.id)
    }))
  );
  return counts;
};

